/**
 * Wall-clock abstraction. Inject into services that need to read "now"
 * or sleep, so tests can mock both without using `jest.useFakeTimers`.
 */
export interface Clock {
  /** Current time in milliseconds since the Unix epoch. */
  now(): number;
  /** Resolves after `ms` milliseconds. */
  delay(ms: number): Promise<void>;
}

/** Default `Clock` backed by `Date.now()` and `setTimeout`. */
export const systemClock: Clock = {
  now: () => Date.now(),
  delay: (ms: number) => new Promise((resolve) => setTimeout(resolve, ms)),
};
